import React, { useEffect, useState } from 'react';
import Container from '../Container/Index';

const Index = () => {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScroll(window.scrollY > 250);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {/* Floating Button */}
      <div
        className={`floatButton desktop-show ${
          isScroll ? 'show' : 'hide'
        } fixed transition-opacity duration-300`}
      >
        <div className="col-12 float-start w-full">
          <button
            className="btn-epic text-white border md:w-[300px] m-md-0 mt-3"
            aria-label="Scroll to top"
            onClick={scrollToTop} 
          >
            <span>Request A Call Back</span>
            <span>Request A Call Back</span>
          </button>
        </div>
      </div>

      {/* Footer Section */}
      <Container _parentClass="py-sm-3 py-2 copyrights w-full">
        <div className="flex flex-wrap w-full">
          <div className="w-full md:w-1/2">
            <small>
              &copy; {new Date().getFullYear()} SS Group | All rights reserved.
            </small>
          </div>
          <div className="w-full md:w-1/2 text-end">
            <small>
              <a
                href="http://triverseadvertising.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                site : triverse
              </a>
            </small>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Index;
